export enum RequestPriority {
	NONE = 'none',
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
}
